import { render, staticRenderFns } from "./MyLive.vue?vue&type=template&id=0cd8c8d9&scoped=true&"
import script from "./MyLive.vue?vue&type=script&lang=js&"
export * from "./MyLive.vue?vue&type=script&lang=js&"
import style0 from "./MyLive.vue?vue&type=style&index=0&id=0cd8c8d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd8c8d9",
  null
  
)

component.options.__file = "MyLive.vue"
export default component.exports